import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DocumentApi extends BaseApi {
    constructor(client) {
        super(client, '/document');
    }

    async associateAssignmentTemplates(id, body) {
        const response = await this.client.post(`${this.basePath}/${id}/assignment-templates`, body);
        return response.data;
    }

    async markDynamicReportDraft(id) {
        const response = await this.client.put(`${this.basePath}/${id}/dynamic-report-draft`);
        return response.data;
    }

    async seedDynamicReportTemplate(id, body = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/dynamic-report-template`, body);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async publishDynamicReportDraft(id, body = {}) {
        const response = await this.client.post(`${this.basePath}/${id}/dynamic-report-draft/publish`, body);
        return response.data;
    }

    async createReportDesignerCapability(id) {
        const response = await this.client.post(`${this.basePath}/${id}/report-designer-capability`, {});
        return response.data;
    }

    async runReport(id, body = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/report-run`, body);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * @returns {{ status: number, data: object }}
     */
    async createWithResponse(body) {
        try {
            const response = await this.client.post(this.basePath, body);
            return { status: response.status, data: response.data };
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * @returns {{ status: number, data: object }}
     */
    async updateWithResponse(id, body) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}`, body);
            return { status: response.status, data: response.data };
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPartyTemplate(params = {}) {
        const response = await this.client.get(`${this.basePath}/party-template`, { params });
        return response.data;
    }

    async getCatalogReportUsage() {
        try {
            const response = await this.client.get(`${this.basePath}/catalog-report-usage`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPublicCatalog() {
        try {
            const response = await this.client.get('/public/documents');
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPublicShare(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/public-share`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async updatePublicShare(id, body) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}/public-share`, body);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getParty(id) {
        const response = await this.client.get(`${this.basePath}/${id}/party`);
        return response.data;
    }

    async syncParty(id, body) {
        const response = await this.client.put(`${this.basePath}/${id}/party`, body);
        return response.data;
    }

    async setApprovers(id, approvers) {
        const response = await this.client.put(`${this.basePath}/${id}/approvers`, { approvers });
        return response.data;
    }

    async setApprovalMode(id, mode) {
        const response = await this.client.put(`${this.basePath}/${id}/approval-mode`, { mode });
        return response.data;
    }

    /**
     * @returns {{ status: number, data: object }}
     */
    async deleteWithResponse(id) {
        try {
            const response = await this.client.delete(`${this.basePath}/${id}`);
            return { status: response.status, data: response.data };
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
